import type { FlowStep } from '@forq/ui';
import { invoiceStatusLabels, type Invoice, type InvoiceDocumentStatus } from '@forq/finance-data';

/** The happy-path document lifecycle shown as a trail even before each step is reached. */
const invoiceFlowOrder: readonly InvoiceDocumentStatus[] = ['draft', 'in_review', 'approved', 'invoiced', 'sent'];
const invoiceRank = new Map<InvoiceDocumentStatus, number>(invoiceFlowOrder.map((status, index) => [status, index]));

/** Builds the FORQ Flow document trail for an invoice (done → current → upcoming, cancelled terminal). */
export function buildInvoiceFlow(invoice: Invoice): readonly FlowStep[] {
  if (invoice.documentStatus === 'cancelled') {
    return [
      { key: 'draft', label: invoiceStatusLabels.draft, state: 'done' },
      { key: 'cancelled', label: invoiceStatusLabels.cancelled, state: 'cancelled' },
    ];
  }
  const currentRank = invoiceRank.get(invoice.documentStatus) ?? 0;
  return invoiceFlowOrder.map((status) => {
    const rank = invoiceRank.get(status) ?? 0;
    return {
      key: status,
      label: invoiceStatusLabels[status],
      state: rank < currentRank ? 'done' : rank === currentRank ? 'current' : 'upcoming',
    };
  });
}
